import React from 'react'
import UsersHandler from 'requests/handlers/usersHandler'
import ExportHandler from 'requests/handlers/exportHandler'
import User from 'requests/objects/user'
import ApiHandler from 'requests/apiHandler'
import ParamsHandler from 'requests/handlers/paramsHandler'
import Param from 'requests/objects/param'
import ExportDto from 'requests/objects/exportDto'

/**
 * @typedef {object} HandlersProps
 * @property {function(object):ApiHandler<any>} handler Function to get proper handler for a desired object
 * @property {UsersHandler} usersHandler User Handler
 * @property {ParamsHandler} paramsHandler Param Handler
 * @property {ExportHandler} exportHandler Param Handler
 */

// eslint-disable-next-line jsdoc/require-returns
/**
 * With handlers hoc
 * @param {object} WrappedComponent Component to wrapp
 */
export default function withHandlers(WrappedComponent) {
    // eslint-disable-next-line react/display-name
    return class extends React.Component {
        constructor(props) {
            super(props)

            // Declare all handlers
            const exportHandler = new ExportHandler()
            const usersHandler = new UsersHandler()
            const paramsHandler = new ParamsHandler()

            /** @type {object} Store handlers in an object */
            this.handlers = {
                exportHandler,
                usersHandler,
                paramsHandler,
            }

            /** @type {function(object):ApiHandler<any>} Function to get proper handler for a desired object */
            this.handler = obj => {
                switch (obj) {
                    case ExportDto:
                        return exportHandler
                    case User:
                        return usersHandler
                    case Param:
                        return paramsHandler
                    default:
                        return null
                }
            }
        }

        render() {
            return (
                <WrappedComponent
                    handler={this.handler}
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...this.handlers}
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...this.props}
                />
            )
        }
    }
}
